'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTranslate = require('@gandi/react-translate');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _supercluster = require('supercluster');

var _supercluster2 = _interopRequireDefault(_supercluster);

var _DiorMap = require('./DiorMap.config');

var _DiorMap2 = _interopRequireDefault(_DiorMap);

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _classname = require('classname');

var _classname2 = _interopRequireDefault(_classname);

var _debounce = require('debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _deepEqual = require('deep-equal');

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _memoizeOne = require('memoize-one');

var _memoizeOne2 = _interopRequireDefault(_memoizeOne);

var _mapApi = require('../../shared/mapApi');

require('./DiorMap.css');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DiorMap = function (_Component) {
  (0, _inherits3.default)(DiorMap, _Component);
  (0, _createClass3.default)(DiorMap, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      var updateMarkersInBounds = false;

      if (!this.props.api) {
        return;
      }

      if (this.props.isMobileShopOpen !== prevProps.isMobileShopOpen) {
        this.triggerResize();
      }

      if (this.props.markers !== prevProps.markers) {
        this.updateMarkers();
        this.updateMarkersWithLabels();
        this.updateClusters();
        updateMarkersInBounds = true;
      }
      if (this.props.location && this.props.location !== prevProps.location) {
        if ((0, _mapApi.isGMap)(this.props.api)) {
          this.map.fitBounds(this.props.location);
        } else {
          this.map.setViewport(this.props.location);
        }
        updateMarkersInBounds = true;
      }
      if (this.props.center && this.props.center !== prevProps.center) {
        if ((0, _mapApi.isGMap)(this.props.api)) {
          this.map.panTo(this.props.center);
          this.setZoom(this.props.zoom);
        } else {
          this.map.centerAndZoom(this.props.center, this.props.zoom);
          this.onBoundsChanged();
        }
        updateMarkersInBounds = true;
      }
      if (this.props.zoom && this.props.zoom !== prevProps.zoom) {
        this.setZoom(this.props.zoom);
      }
      this.updatePositionMarker();
      this.updateMarkersWithLabels();
      if (this.props.selectedMarker && this.props.selectedMarker !== prevProps.selectedMarker) {
        this.updateSelectedMarker();
        if (this.props.idsWithLabels.indexOf(this.props.selectedMarker) === -1) {
          updateMarkersInBounds = true;
        }
      }
      if (this.props.itinerary !== prevProps.itinerary) {
        this.updateItinerary();
      }
      this.updateDisplay();

      if (updateMarkersInBounds) {
        this.mapReadyPromise.then(function () {
          _this2.updateVisibleMarkers();
          _this2.updateMarkersInBounds(true);
        });
      }

      if (this.props.displayType !== prevProps.displayType) {
        this.triggerResize();
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.api) {
        this.initIcons();
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      if (nextProps.api && !this.props.api) {
        this.initIcons();
      }
    }
  }]);

  function DiorMap(props) {
    (0, _classCallCheck3.default)(this, DiorMap);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DiorMap.__proto__ || (0, _getPrototypeOf2.default)(DiorMap)).call(this, props));

    _this.getMarkersFromBounds = (0, _memoizeOne2.default)(function (swLng, swLat, neLng, neLat, markers) {
      return R.values(markers).filter(function (marker) {
        var _marker = (0, _slicedToArray3.default)(marker, 3),
            lat = _marker[1],
            lng = _marker[2];

        return neLat >= lat && swLat <= lat && neLng >= lng && swLng <= lng;
      }).map(function (marker) {
        return marker[0];
      });
    });

    _this.start = Date.now();

    _this.resolveMapReadyPromise;
    _this.mapReadyPromise = new _promise2.default(function (resolve) {
      return _this.resolveMapReadyPromise = resolve;
    });

    _this.markers = {};
    _this.markersWithLabels = [];
    _this.clusters = [];
    _this.originMarker = null;
    _this.positionMarker = null;
    _this.markersInBounds = [];

    _this.state = { isButtonVisible: false };
    _this.onBaiduMapReady = _this.onBaiduMapReady.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(DiorMap, [{
    key: 'displayClusters',
    value: function displayClusters() {
      var _this3 = this;

      if (this.clusters && this.clusters.length > 0) {
        if ((0, _mapApi.isGMap)(this.props.api)) {
          this.clusters.forEach(function (cluster) {
            return cluster.setMap(_this3.map);
          });
        } else {
          this.clusters.forEach(function (cluster) {
            return _this3.map.addOverlay(cluster);
          });
        }
      }
    }
  }, {
    key: 'displayMarkers',
    value: function displayMarkers() {
      var _this4 = this;

      if ((0, _mapApi.isGMap)(this.props.api)) {
        this.markersWithLabels.forEach(function (marker, index) {
          if (!marker.isVisible) {
            marker.setMap(_this4.map);
            marker.setIcon(marker.key === _this4.props.selectedMarker ? _this4.icons.selected : _this4.icons.pin);
            _this4.formatLabel(marker, index + 1 + '', marker.key === _this4.props.selectedMarker ? 'white' : 'black');
          }
          marker.isVisible = true;
        });
      } else {
        this.markersWithLabels.forEach(function (marker, index) {
          if (!marker.isVisible) {
            _this4.map.addOverlay(marker);
            marker.setIcon(marker.key === _this4.props.selectedMarker ? _this4.icons.selected : _this4.icons.pin);
            _this4.formatLabel(marker, index + 1 + '', marker.key === _this4.props.selectedMarker ? 'white' : 'black');
          }
          marker.isVisible = true;
        });
      }
    }
  }, {
    key: 'formatCluster',
    value: function formatCluster(cluster, index) {
      var marker = void 0;
      if ((0, _mapApi.isGMap)(this.props.api)) {
        marker = new this.props.api.Marker({
          icon: this.icons.cluster1,
          key: cluster.properties ? cluster.properties.cluster_id : null,
          map: this.map,
          optimized: false,
          position: new this.props.api.LatLng(+cluster.geometry.coordinates[1], +cluster.geometry.coordinates[0])
        });
        this.props.api.event.addListenerOnce(marker, 'click', this.onClusterClick.bind(this, index));
      } else {
        marker = new this.props.api.Marker(new this.props.api.Point(+cluster.geometry.coordinates[0], +cluster.geometry.coordinates[1]), { icon: this.icons.cluster1 });
        marker.key = cluster.properties ? cluster.properties.cluster_id : null;
        this.map.addOverlay(marker);
        marker.boundedOnClusterClick = this.onClusterClick.bind(this, index);
        marker.addEventListener('click', marker.boundedOnClusterClick);
      }
      this.formatLabel(marker, cluster.properties ? cluster.properties.point_count : '1', 'white', 18);
      return marker;
    }
  }, {
    key: 'formatLabel',
    value: function formatLabel(marker, text) {
      var color = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'black';
      var fontSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 14;

      if ((0, _mapApi.isGMap)(this.props.api)) {
        marker.setLabel({
          text: text + '',
          color: color,
          fontFamily: 'Century-Gothic, Arial, sans-serif',
          fontSize: fontSize + 'px'
        });
      } else {
        var _marker$getIcon$size = marker.getIcon().size,
            height = _marker$getIcon$size.height,
            width = _marker$getIcon$size.width;

        var label = new this.props.api.Label(text);
        label.setStyle({
          backgroundColor: 'transparent',
          border: 0,
          color: color,
          fontFamily: 'Century-Gothic, Arial, sans-serif',
          fontSize: fontSize + 'px',
          height: height + 'px',
          lineHeight: height + 'px',
          textAlign: 'center',
          width: width + 'px'
        });
        marker.setLabel(label);
      }
    }

    /**
     * Each marker is represented by an array containing following informations :
     * - 0 => id
     * - 1 => latitude
     * - 2 => longitude
     * - 3 => categories (array of category id)
     */

  }, {
    key: 'formatMarker',
    value: function formatMarker(data) {
      var marker = void 0;
      if ((0, _mapApi.isGMap)(this.props.api)) {
        marker = new this.props.api.Marker({
          isVisible: false,
          key: data[0],
          label: '',
          optimized: false,
          position: new this.props.api.LatLng(+data[1], +data[2]),
          zIndex: +data[4]
        });
      } else {
        marker = new this.props.api.Marker(new this.props.api.Point(+data[2], +data[1]));
        marker.isVisible = false;
        marker.key = data[0];
      }
      return marker;
    }
  }, {
    key: 'getMarkersInBounds',
    value: function getMarkersInBounds() {
      var bounds = this.map.getBounds();
      if (bounds) {
        if ((0, _mapApi.isGMap)(this.props.api)) {
          var NE = bounds.getNorthEast();
          var SW = bounds.getSouthWest();
          return [].concat((0, _toConsumableArray3.default)(this.getMarkersFromBounds(Math.max(SW.lng(), -180), SW.lat(), Math.min(NE.lng(), 180), NE.lat(), this.props.markers)));
        } else {
          var _NE = bounds.getNorthEast();
          var _SW = bounds.getSouthWest();
          return [].concat((0, _toConsumableArray3.default)(this.getMarkersFromBounds(Math.max(_SW.lng, -180), _SW.lat, Math.min(_NE.lng, 180), _NE.lat, this.props.markers)));
        }
      }
      return [];
    }
  }, {
    key: 'hideClusters',
    value: function hideClusters() {
      var _this5 = this;

      if (this.clusters && this.clusters.length > 0) {
        if ((0, _mapApi.isGMap)(this.props.api)) {
          this.clusters.forEach(function (cluster) {
            return cluster.setMap(null);
          });
        } else {
          this.clusters.forEach(function (cluster) {
            return _this5.map.removeOverlay(cluster);
          });
        }
      }
    }
  }, {
    key: 'hideMarkers',
    value: function hideMarkers() {
      var _this6 = this;

      if (this.markersWithLabels && this.markersWithLabels.length > 0) {
        if ((0, _mapApi.isGMap)(this.props.api)) {
          this.markersWithLabels.forEach(function (marker) {
            marker.setMap(null);
            marker.isVisible = false;
          });
        } else {
          this.markersWithLabels.forEach(function (marker) {
            _this6.map.removeOverlay(marker);
            marker.isVisible = false;
          });
        }
      }
    }
  }, {
    key: 'initIcons',
    value: function initIcons() {
      if ((0, _mapApi.isGMap)(this.props.api)) {
        this.icons = {
          cluster1: {
            anchor: new this.props.api.Point(36, 36),
            scaledSize: new this.props.api.Size(72, 72),
            url: this.props.baseUrl + 'assets/images/cluster1.svg'
          },
          pin: {
            anchor: new this.props.api.Point(18, 18),
            scaledSize: new this.props.api.Size(36, 36),
            url: this.props.baseUrl + 'assets/images/pin.svg'
          },
          positionIcon: {
            anchor: new this.props.api.Point(8, 22),
            scaledSize: new this.props.api.Size(16, 44),
            url: this.props.baseUrl + 'assets/images/position.svg'
          },
          selected: {
            anchor: new this.props.api.Point(18, 18),
            scaledSize: new this.props.api.Size(36, 36),
            url: this.props.baseUrl + 'assets/images/pin-selected.svg'
          },
          startIcon: {
            size: new this.props.api.Size(20, 20),
            anchor: new this.props.api.Point(10, 10),
            scaledSize: new this.props.api.Size(20, 20),
            url: this.props.baseUrl + 'assets/images/pin-start.svg'
          }
        };
      } else {
        this.icons = {
          cluster1: new this.props.api.Icon(this.props.baseUrl + 'assets/images/cluster1.svg', new this.props.api.Size(72, 72), { anchor: new this.props.api.Size(36, 36) }),
          pin: new this.props.api.Icon(this.props.baseUrl + 'assets/images/pin.svg', new this.props.api.Size(36, 36), { anchor: new this.props.api.Size(18, 18) }),
          positionIcon: new this.props.api.Icon(this.props.baseUrl + 'assets/images/position.svg', new this.props.api.Size(16, 22), { anchor: new this.props.api.Size(8, 22) }),
          selected: new this.props.api.Icon(this.props.baseUrl + 'assets/images/pin-selected.svg', new this.props.api.Size(36, 36), { anchor: new this.props.api.Size(18, 18) }),
          startIcon: new this.props.api.Icon(this.props.baseUrl + 'assets/images/pin-start.svg', new this.props.api.Size(20, 20), { anchor: new this.props.api.Size(10, 10) })
        };
      }
    }
  }, {
    key: 'initMarkerClusterer',
    value: function initMarkerClusterer() {
      var features = this.props.markers.map(function (marker) {
        return {
          geometry: {
            coordinates: [+marker[2], +marker[1]],
            type: 'Point'
          },
          properties: null,
          type: 'Features'
        };
      });
      if ((0, _mapApi.isGMap)(this.props.api)) {
        this.markerClusterer = (0, _supercluster2.default)({
          extent: 512,
          radius: this.props.gridSize
        });
      } else {
        this.markerClusterer = (0, _supercluster2.default)({
          extent: 256,
          radius: this.props.gridSize
        });
      }
      this.markerClusterer.load(features);
    }
  }, {
    key: 'onBoundsChanged',
    value: function onBoundsChanged() {
      this.updateButton();
      this.updateClusters();
      this.updateDisplay();
      this.updateVisibleMarkers();
      this.updateMarkersInBounds();
      if (!(0, _mapApi.isGMap)(this.props.api)) {
        this.onBaiduMapReady();
      }
    }
  }, {
    key: 'onButtonClick',
    value: function onButtonClick(event) {
      event.preventDefault();
      this.updateVisibleMarkers();
      this.updateMarkersInBounds(true);
      this.setState({ isButtonVisible: false });
    }
  }, {
    key: 'onClusterClick',
    value: function onClusterClick(key) {
      var center = this.clusters[key].getPosition();
      var zoom = this.map.getZoom() === this.props.maxZoom || this.clusters[key].key === null ? this.props.maxZoom + 1 : this.markerClusterer.getClusterExpansionZoom(this.clusters[key].key, this.map.getZoom());
      if ((0, _mapApi.isGMap)(this.props.api)) {
        this.map.panTo(center);
        this.setZoom(zoom);
      } else {
        this.map.centerAndZoom(center, zoom);
      }
    }
  }, {
    key: 'onInit',
    value: function onInit(mapElement) {
      var _this7 = this;

      if (mapElement && !this.map) {
        // Create map.
        if ((0, _mapApi.isGMap)(this.props.api)) {
          this.map = new this.props.api.Map(mapElement, {
            center: { lat: 0, lng: 0 },
            mapTypeControl: false,
            mapTypeId: this.props.api.MapTypeId.ROADMAP,
            streetViewControl: false,
            styles: _DiorMap2.default,
            zoom: this.props.zoom,
            fullscreenControl: true,
            fullscreenControlOptions: {
              position: this.props.api.ControlPosition.TOP_LEFT
            },
            gestureHandling: 'greedy'
          });
          this.props.api.event.addListenerOnce(this.map, 'idle', this.onMapReady.bind(this));
          this.props.api.event.addListener(this.map, 'bounds_changed', (0, _debounce2.default)(this.onBoundsChanged.bind(this), 200));
          this.props.api.event.addListener(this.map, 'zoom_changed', this.onZoomChanged.bind(this));
        } else {
          this.map = new this.props.api.Map(mapElement, {
            mapTypeId: this.props.api.MapType.BMAP_NORMAL_MAP
          });
          this.map.centerAndZoom(new this.props.api.Point(0, 0), this.props.zoom);
          this.map.addControl(new this.props.api.NavigationControl());
          this.map.enableScrollWheelZoom();
          this.map.setMapStyle({ style: 'grayscale' });
          this.map.addEventListener('tilesloaded', this.onBaiduMapReady);
          this.map.addEventListener('movend', this.onBoundsChanged.bind(this));
          this.map.addEventListener('dragend', this.onBoundsChanged.bind(this));
          this.map.addEventListener('zoomend', this.onZoomChanged.bind(this));
          this.map.addEventListener('zoomend', this.onBoundsChanged.bind(this));
        }

        // Create special markers.
        if ((0, _mapApi.isGMap)(this.props.api)) {
          this.positionMarker = new this.props.api.Marker({
            icon: this.icons.startIcon,
            clickable: false,
            optimized: false,
            zIndex: this.props.api.Marker.MAX_ZINDEX + 2
          });
          this.originMarker = new this.props.api.Marker({
            icon: this.icons.startIcon,
            optimized: false,
            clickable: false
          });
          this.destinationMarker = new this.props.api.Marker({
            icon: this.icons.selected,
            optimized: false,
            clickable: false
          });
          this.formatLabel(this.destinationMarker, '1', 'white');
        } else {
          this.positionMarker = new this.props.api.Marker(null, {
            optimized: false,
            icon: this.icons.startIcon
          });
          this.originMarker = new this.props.api.Marker(null, {
            icon: this.icons.startIcon,
            clickable: false,
            optimized: false,
            map: this.map,
            visible: false
          });
          this.destinationMarker = new this.props.api.Marker(null, {
            icon: this.icons.selected,
            optimized: false,
            clickable: false,
            map: this.map,
            visible: false
          });
          this.formatLabel(this.destinationMarker, '1', 'white');
        }

        // Update map.
        this.updateMap();

        // Create markers.
        this.updateMarkers();
        this.updateMarkersWithLabels();
        this.updateSelectedMarker();
        if (this.props.selectedMarker) {
          this.mapReadyPromise.then(function () {
            _this7.updateVisibleMarkers();
            _this7.updateMarkersInBounds(true);
          });
        }

        // Display itinerary.
        if (this.props.itinerary) {
          this.updateItinerary();
        }

        // Update display.
        this.updateDisplay();
      }
    }
  }, {
    key: 'onBaiduMapReady',
    value: function onBaiduMapReady() {
      if (!this.props.isMapReady) {
        this.onMapReady();
        this.map.removeEventListener('tilesloaded', this.onBaiduMapReady);
      }
    }
  }, {
    key: 'onMapReady',
    value: function onMapReady() {
      if (!this.props.isMapReady) {
        this.resolveMapReadyPromise();
        this.updateClusters();
        this.updateDisplay();
        this.props.mapReady(this.map);
      }
    }
  }, {
    key: 'onZoomChanged',
    value: function onZoomChanged() {
      this.props.zoomChanged(this.map.getZoom());
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'DiorMap', style: this.props.style },
        _react2.default.createElement('div', { ref: this.onInit.bind(this), style: { height: '100%' } }),
        _react2.default.createElement(
          'a',
          {
            className: (0, _classname2.default)('DiorMap__button', { 'hidden-xs-up': !this.state.isButtonVisible }),
            href: '#',
            onClick: this.onButtonClick.bind(this)
          },
          this.props.__('DiorMap|Search in this area')
        )
      );
    }
  }, {
    key: 'setZoom',
    value: function setZoom(zoom) {
      if (this.map.getZoom() !== zoom) {
        this.map.setZoom(zoom);
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nexState) {
      return !(0, _deepEqual2.default)(nextProps, this.props, { strict: true }) || !(0, _deepEqual2.default)(nexState, this.state, { strict: true });
    }
  }, {
    key: 'triggerResize',
    value: function triggerResize() {
      if ((0, _mapApi.isGMap)(this.props.api)) {
        this.props.api.event.trigger(this.map, 'resize');
      } else {
        this.map.enableAutoResize();
      }
    }
  }, {
    key: 'updateButton',
    value: function updateButton() {
      if (this.props.itinerary) {
        return;
      }

      var bounds = this.map.getBounds();
      var markers = this.getMarkersInBounds();

      if (this.props.itinerary) {
        // In itinerary mode, do not display the button.
        this.setState({ isButtonVisible: false });
      } else if (markers.length > this.props.maxResult) {
        // Too many results => hide button.
        this.setState({ isButtonVisible: false });
      } else if (this.props.bounds) {
        // New area not strictly included inside the previous one => display reload button.
        if ((0, _mapApi.isGMap)(this.props.api)) {
          if (!this.props.bounds.contains(bounds.getNorthEast()) || !this.props.bounds.contains(bounds.getSouthWest())) {
            this.setState({ isButtonVisible: true });
          } else {
            this.setState({ isButtonVisible: false });
          }
        } else {
          if (!this.props.bounds.containsPoint(bounds.getNorthEast()) || !this.props.bounds.containsPoint(bounds.getSouthWest())) {
            this.setState({ isButtonVisible: true });
          } else {
            this.setState({ isButtonVisible: false });
          }
        }
      }
    }
  }, {
    key: 'updateClusters',
    value: function updateClusters() {
      var _this8 = this;

      if (this.props.itinerary) {
        return;
      }

      if (this.clusters && this.clusters.length > 0) {
        if ((0, _mapApi.isGMap)(this.props.api)) {
          this.clusters.forEach(function (cluster) {
            cluster.setMap(null);
            _this8.props.api.event.clearListeners(cluster, 'click');
          });
        } else {
          this.clusters.forEach(function (cluster) {
            _this8.map.removeOverlay(cluster);
            cluster.removeEventListener('click', cluster.boundedOnClusterClick);
          });
        }
        this.clusters = [];
      }

      var bounds = this.map.getBounds();
      var markers = this.getMarkersInBounds();
      if (bounds && markers.length > this.props.maxResult) {
        if ((0, _mapApi.isGMap)(this.props.api)) {
          var NE = bounds.getNorthEast();
          var SW = bounds.getSouthWest();
          this.clusters = this.markerClusterer.getClusters([Math.max(SW.lng(), -180), SW.lat(), Math.min(NE.lng(), 180), NE.lat()], this.map.getZoom()).map(this.formatCluster.bind(this));
        } else {
          var _NE2 = bounds.getNorthEast();
          var _SW2 = bounds.getSouthWest();
          this.clusters = this.markerClusterer.getClusters([Math.max(_SW2.lng, -180), _SW2.lat, Math.min(_NE2.lng, 180), _NE2.lat], this.map.getZoom()).map(this.formatCluster.bind(this));
        }
      }
    }
  }, {
    key: 'updateDisplay',
    value: function updateDisplay() {
      if (this.props.itinerary) {
        return;
      }

      var markers = this.getMarkersInBounds();
      if (markers.length > this.props.maxResult) {
        this.hideMarkers();
        this.displayClusters();
      } else {
        this.hideClusters();
        this.displayMarkers();
      }
    }
  }, {
    key: 'updateItinerary',
    value: function updateItinerary() {
      if (this.props.itinerary) {
        this.hideMarkers();
        this.hideClusters();
        if ((0, _mapApi.isGMap)(this.props.api)) {
          this.originMarker.setPosition(this.props.itinerary.startPoint);
          this.originMarker.setMap(this.map);
          this.destinationMarker.setPosition(this.props.itinerary.endPoint);
          this.destinationMarker.setMap(this.map);
          this.positionMarker.setMap(null);
        }
      } else {
        if ((0, _mapApi.isGMap)(this.props.api)) {
          this.originMarker.setMap(null);
          this.destinationMarker.setMap(null);
        } else {
          this.map.removeOverlay(this.originMarker);
          this.map.removeOverlay(this.destinationMarker);
        }
        this.updatePositionMarker();
        this.updateClusters();
        this.updateDisplay();
      }
    }
  }, {
    key: 'updateMap',
    value: function updateMap() {
      if (this.props.location) {
        if ((0, _mapApi.isGMap)(this.props.api)) {
          this.map.fitBounds(this.props.location);
        } else {
          this.map.setViewport(this.props.location);
        }
      } else if (this.props.center) {
        if ((0, _mapApi.isGMap)(this.props.api)) {
          this.map.panTo(this.props.center);
          this.setZoom(this.props.zoom);
        } else {
          this.map.centerAndZoom(this.props.center, this.props.zoom);
        }
      } else if (this.props.zoom) {
        this.setZoom(this.props.zoom);
      }
    }
  }, {
    key: 'updateMarkers',
    value: function updateMarkers() {
      var _this9 = this;

      // Clear.
      if ((0, _mapApi.isGMap)(this.props.api)) {
        R.values(this.markers).forEach(function (marker) {
          marker.setMap(null);
          _this9.props.api.event.clearListeners(marker, 'click');
        });
      } else {
        R.values(this.markers).forEach(function (marker) {
          _this9.map.removeOverlay(marker);
          marker.removeEventListener('click', _this9.props.markerClicked);
        });
      }

      // Markers.
      this.markers = this.props.markers.map(this.formatMarker.bind(this)).reduce(function (prev, marker) {
        prev[marker.key] = marker;
        return prev;
      }, {});
      if ((0, _mapApi.isGMap)(this.props.api)) {
        R.values(this.markers).forEach(function (marker) {
          return _this9.props.api.event.addListener(marker, 'click', _this9.props.markerClicked);
        });
      } else {
        R.values(this.markers).forEach(function (marker) {
          return marker.addEventListener('click', _this9.props.markerClicked);
        });
      }

      // Init clusters.
      this.initMarkerClusterer();
    }
  }, {
    key: 'updateMarkersInBounds',
    value: function updateMarkersInBounds() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var bounds = this.map.getBounds();
      var markersInBounds = this.getMarkersInBounds();

      if (markersInBounds.length <= this.props.maxResult && this.markersInBounds.length > this.props.maxResult || force) {
        this.props.updateMarkersInBounds([].concat((0, _toConsumableArray3.default)(markersInBounds)), this.map.getZoom(), bounds);
      }
      this.markersInBounds = markersInBounds;
    }
  }, {
    key: 'updateMarkersWithLabels',
    value: function updateMarkersWithLabels() {
      var _this10 = this;

      if (this.props.idsWithLabels.length > 0) {
        this.hideMarkers();
        this.markersWithLabels = this.props.idsWithLabels.filter(function (id) {
          return _this10.markers[id];
        }).map(function (id) {
          return _this10.markers[id];
        });
      }
    }
  }, {
    key: 'updatePositionMarker',
    value: function updatePositionMarker() {
      if (this.props.center) {
        this.positionMarker.setPosition(this.props.center);
        if ((0, _mapApi.isGMap)(this.props.api)) {
          this.positionMarker.setMap(this.map);
        } else {
          this.map.addOverlay(this.positionMarker);
        }
      } else {
        if ((0, _mapApi.isGMap)(this.props.api)) {
          this.positionMarker.setMap(null);
        } else {
          this.map.removeOverlay(this.positionMarker);
        }
      }
    }
  }, {
    key: 'updateSelectedMarker',
    value: function updateSelectedMarker() {
      if (this.props.selectedMarker && this.markers[this.props.selectedMarker]) {
        this.map.panTo(this.markers[this.props.selectedMarker].getPosition());
      }
    }
  }, {
    key: 'updateVisibleMarkers',
    value: function updateVisibleMarkers() {
      var markers = this.getMarkersInBounds();
      this.props.updateVisibleMarkers([].concat((0, _toConsumableArray3.default)(markers)), this.map.getZoom());
    }
  }]);
  return DiorMap;
}(_react.Component);

DiorMap.propTypes = {
  __: _propTypes2.default.func.isRequired, // @see https://github.com/Gandi/react-translate
  api: _propTypes2.default.object,
  baseUrl: _propTypes2.default.string,
  bounds: _propTypes2.default.object,
  center: _propTypes2.default.any,
  displayType: _propTypes2.default.number,
  gridSize: _propTypes2.default.number,
  idsWithLabels: _propTypes2.default.array,
  isMapReady: _propTypes2.default.number,
  isMobileShopOpen: _propTypes2.default.bool,
  itinerary: _propTypes2.default.object,
  location: _propTypes2.default.any,
  mapReady: _propTypes2.default.func,
  mapStyles: _propTypes2.default.object,
  markerClicked: _propTypes2.default.func,
  markers: _propTypes2.default.array,
  maxResult: _propTypes2.default.number,
  maxZoom: _propTypes2.default.number,
  selectedMarker: _propTypes2.default.string,
  updateMarkersInBounds: _propTypes2.default.func,
  updateVisibleMarkers: _propTypes2.default.func,
  zoom: _propTypes2.default.number,
  zoomChanged: _propTypes2.default.func
};

DiorMap.defaultProps = {
  api: null,
  baseUrl: '',
  bounds: null,
  center: null,
  displayType: 1,
  gridSize: 300,
  idsWithLabels: [],
  isMapReady: 0,
  isMobileShopOpen: false,
  itinerary: null,
  location: null,
  mapReady: function mapReady() {},
  mapStyles: {},
  markerClicked: function markerClicked() {},
  markers: [],
  maxResult: 100,
  maxZoom: 13,
  selectedMarker: null,
  updateMarkersInBounds: function updateMarkersInBounds() {},
  updateVisibleMarkers: function updateVisibleMarkers() {},
  zoom: 2,
  zoomChanged: function zoomChanged() {}
};

exports.default = (0, _reactTranslate.withTranslator)()(DiorMap);

// dev API key => AIzaSyBWi9gGK0JZV3J2DzkyMDXyJRtE1dIGTHQ


//////////////////
// WEBPACK FOOTER
// ./~/ui-kit/src/components/DiorMap/DiorMap.js
// module id = 1163
// module chunks = 0